(function(root){
  'use strict';
  var PRODUCT='/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
  var MAX_MESSAGE=1300, MAX_FRAGMENT=6000;
  var COPY={intro:'Bonjour, j’ai une question à propos de ma formule.',name:'Nom de la formule :',link:'Lien de la formule :',prompt:'Ma demande :',status:'Contexte du pot ajouté. Complète ta demande avant d’envoyer.',preserved:'Ton message a été conservé. Le contexte du pot n’a pas été ajouté.',invalid:'Le contexte du pot n’a pas pu être ajouté. Décris ta demande ci-dessous.'};

  function normalize(value){
    if(typeof value!=='string'||/[\u0000-\u001f\u007f-\u009f]/.test(value))return '';
    var name=value.normalize('NFC').trim(),points=Array.from(name);
    if(!points.length||points.length>50)return '';
    for(var i=0;i<points.length;i++){var code=points[i].codePointAt(0);if(code>=0xd800&&code<=0xdfff)return '';}
    return name;
  }

  function decode(value){
    if(typeof value!=='string'||!value||value.length>MAX_FRAGMENT||!/^[A-Za-z0-9_-]+$/.test(value)||value.length%4===1)return null;
    try{
      var padded=value.replace(/-/g,'+').replace(/_/g,'/');while(padded.length%4)padded+='=';
      var binary=root.atob(padded),bytes=new Uint8Array(binary.length);
      for(var i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
      return JSON.parse(new TextDecoder('utf-8',{fatal:true}).decode(bytes));
    }catch(_){return null;}
  }

  function encode(value){
    var bytes=new TextEncoder().encode(JSON.stringify(value)),binary='';
    for(var i=0;i<bytes.length;i++)binary+=String.fromCharCode(bytes[i]);
    return root.btoa(binary).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  }

  function recipeUrl(raw,name){
    if(typeof raw!=='string'||raw.length>12000)return '';
    try{
      var url=new URL(raw);
      if(!/^https?:$/.test(url.protocol)||url.username||url.password||url.port)return '';
      if(['www.mynutrilab.com','mynutrilab.com'].indexOf(url.hostname)<0)return '';
      if(url.pathname!==PRODUCT&&url.pathname!==PRODUCT+'/')return '';
      var r=url.searchParams.getAll('r'),f=url.searchParams.getAll('f');
      if(r.length+f.length!==1)return '';
      var key=r.length?'r':'f',value=(r.length?r:f)[0];
      if(key==='r'){
        if(!/^\d{16}(?:\d{1,3})?$/.test(value))return '';
        if(value.length>16&&(value.charAt(3)!=='8'&&value.charAt(3)!=='9'||!/^([6-9]|[1-9]\d{1,2})$/.test(value.slice(16))))return '';
      }else{
        if(!value||value.length>4000)return '';
        var parsed=decode(value);
        if(!parsed||typeof parsed!=='object'||Array.isArray(parsed))return '';
        if(!parsed.d||typeof parsed.d!=='object'||Array.isArray(parsed.d)||!parsed.e||typeof parsed.e!=='object'||Array.isArray(parsed.e))return '';
        if(Object.keys(parsed).some(function(k){return ['s','i','f','fl','n','nc','sb','creatineRemoved','o','nm','lt','d','e','g','gi'].indexOf(k)<0;}))return '';
      }
      return 'https://www.mynutrilab.com'+PRODUCT+'?'+key+'='+value+'#nm='+encodeURIComponent(name);
    }catch(_){return '';}
  }

  function message(context,copy){
    copy=copy||COPY;
    return copy.intro+'\n\n'+copy.name+' '+context.nm+'\n'+copy.link+' '+context.url+'\n\n'+copy.prompt+'\n';
  }

  function context(raw,name){
    var nm=normalize(name);if(!nm)return null;
    var url=recipeUrl(raw,nm);if(!url)return null;
    var data={v:1,url:url,nm:nm};
    return message(data).length<=MAX_MESSAGE?data:null;
  }

  function build(raw,name){
    try{var data=context(raw,name);return data?'/pages/contact#pot='+encode(data):'';}catch(_){return '';}
  }

  function readHash(hash){
    var present=false,bad=false,values=[];
    if(typeof hash!=='string')return {present:false,data:null};
    var parts=hash.replace(/^#/,'').split('&');
    for(var i=0;i<parts.length;i++){
      var at=parts[i].indexOf('='),key='',value='';
      try{key=decodeURIComponent(at<0?parts[i]:parts[i].slice(0,at));}catch(_){bad=true;}
      if(key==='pot')present=true;
      try{value=decodeURIComponent(at<0?'':parts[i].slice(at+1));}catch(_){bad=true;}
      if(key==='pot')values.push(value);
    }
    if(!present||bad||hash.length>MAX_FRAGMENT||values.length!==1)return {present:present,data:null};
    var decoded=decode(values[0]);
    if(!decoded||typeof decoded!=='object'||Array.isArray(decoded)||decoded.v!==1||Object.keys(decoded).sort().join(',')!=='nm,url,v')return {present:true,data:null};
    var data=context(decoded.url,decoded.nm);
    if(!data||data.url!==decoded.url||data.nm!==decoded.nm)return {present:true,data:null};
    return {present:true,data:data};
  }

  function fromHash(hash){return readHash(hash).data;}

  function init(doc,hash){
    doc=doc||root.document;
    if(!doc)return 'absent';
    var status=doc.querySelector('[data-mnl-qr-support]'),field=doc.getElementById('mnlCtMessage'),subject=doc.getElementById('mnlCtSubject');
    if(!status||!field)return 'absent';
    if(status.getAttribute('data-qr-processed')==='true')return 'processed';
    var result=readHash(typeof hash==='string'?hash:root.location.hash);
    if(!result.present)return 'absent';
    var copy={};Object.keys(COPY).forEach(function(k){copy[k]=status.getAttribute('data-qr-'+k)||COPY[k];});
    function show(kind){status.textContent=copy[kind];status.hidden=false;status.setAttribute('data-qr-processed','true');return kind;}
    if(!result.data)return show('invalid');
    if(field.value)return show('preserved');
    var draft=message(result.data,copy),limit=field.maxLength>0?Math.min(field.maxLength,1500):1500;
    if(draft.length>limit)return show('invalid');
    field.value=draft;
    if(subject&&!subject.value){
      var choices=Array.prototype.map.call(subject.options,function(o){return o.value;});
      if(choices.indexOf('Question dosage / composition')>=0)subject.value='Question dosage / composition';
      else if(choices.indexOf('Autre')>=0)subject.value='Autre';
    }
    field.dispatchEvent(new root.Event('input',{bubbles:true}));
    return show('status');
  }

  root.MNL_QR_SUPPORT=Object.freeze({build:build,fromHash:fromHash,normalize:normalize,init:init});
  if(root.document){
    if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',function(){init();},{once:true});
    else init();
  }
})(typeof globalThis!=='undefined'?globalThis:window);
